module.exports = __webpack_public_path__ + "static/media/ic_add_green.557a9796.svg";